import PropTypes from 'prop-types';
import React from 'react';

import {MAPS} from 'js/common';

// Components
import StarRating from 'js/components/star_rating';

const RatingSection = ({handleClickScore, postUserScore, avgUserScore}) => (
    <div className="rating">
        <div className="score-content-text">Score this Content</div>
        <StarRating
            starCount={5}
            starsFilled={postUserScore}
            clickScore={handleClickScore}
            tooltips={MAPS.ContentScoreDescription}
        />
        <div className="text-center text-color-white avg-score">
            {avgUserScore ? `Avg ${avgUserScore}` : null}
        </div>
    </div>
);

RatingSection.propTypes = {
    handleClickScore: PropTypes.func.isRequired,
    postUserScore: PropTypes.number,
    avgUserScore: PropTypes.number
};

export default RatingSection;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid_item/rating_section.js